import React from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from './Footer';
import { usePath, useVideoConfig } from '../../config/VideoAppContext';
import { useLoginState } from '../../providers/DataProvider/DataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultFooter = () => {
  const {
    settingsPath,
    helpPath
  } = usePath();
  const {
    t
  } = useTranslation();
  const {
    personalizationSupported,
    footer,
    businessUnit
  } = useVideoConfig();
  const {
    isLoggedIn
  } = useLoginState();
  const {
    internalLinks = []
  } = footer;
  const aggregatedInternalLinks = [{
    title: t('global.help'),
    url: helpPath,
    type: 'Link'
  }, ...internalLinks];

  // needed to enable reordering exception for RTS
  const getEnrichedLinks = () => {
    switch (businessUnit) {
      case 'rts':
        return [{
          title: 'Télécharger l’app Play RTS sur smartphone',
          url: 'http://playrts.app.link/',
          type: 'Link'
        }, {
          title: "S'abonner à nos newsletters",
          url: 'https://www.rts.ch/newsletters/',
          type: 'Link'
        }, personalizationSupported && !isLoggedIn ? {
          title: 'Paramètres de personnalisation',
          url: settingsPath,
          type: 'Link'
        } : undefined, ...aggregatedInternalLinks].filter(Boolean);
      default:
        return personalizationSupported && !isLoggedIn ? [{
          title: t('global.settings'),
          url: settingsPath,
          type: 'Link'
        }, ...aggregatedInternalLinks] : aggregatedInternalLinks;
    }
  };
  return /*#__PURE__*/_jsx(Footer, {
    config: {
      ...footer,
      internalLinks: getEnrichedLinks()
    }
  });
};